import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { Component } from 'react';
export class ErrorBoundary extends Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", {
      error: undefined,
      errorInfo: undefined
    });
  }
  static getDerivedStateFromError(error) {
    return {
      error
    };
  }
  componentDidCatch(error, errorInfo) {
    const {
      debug,
      logger
    } = this.props;
    this.setState({
      errorInfo
    });
    if (logger) {
      logger.log({
        error,
        errorInfo
      });
    }
    if (debug || !logger) {
      console.error({
        error,
        errorInfo
      }); // eslint-disable-line no-console -- Used for logging error to console.
    }
  }
  render() {
    const {
      error,
      errorInfo
    } = this.state;
    const {
      children,
      fallback
    } = this.props;
    if (error) {
      if (typeof fallback === 'function') {
        return fallback({
          error,
          errorInfo
        }) ?? null;
      }
      return fallback ?? null;
    }
    return children;
  }
}
//# sourceMappingURL=ErrorBoundary.js.map